// Global app-mode flags for Sport League.
//
// These let us turn the app into a free-to-play experience and hide all
// monetization UI WITHOUT deleting any code, so it can be brought back later
// by simply flipping a flag.
//
//   FREE_TO_PLAY  -> tournaments are click-to-join. No tickets / cash / keys
//                    are required to enter, and the tournament type picker
//                    (casual / standard / high stakes / VIP) collapses into a
//                    single JOIN action.
//   SHOP_ENABLED  -> when false, the Shop and all pricing/checkout UI is
//                    hidden (nav links, routes, membership & avatar purchase
//                    prompts). The wallet (tickets / star coins) and challenges
//                    are intentionally left untouched.
//
// To re-enable monetization later: set FREE_TO_PLAY = false and
// SHOP_ENABLED = true.

export const FREE_TO_PLAY = true;
export const SHOP_ENABLED = false;
